import React, { useState, useEffect, useRef, useContext } from "react";
import {
  CurrencyChange,
  UserType,
  Languages,
  ShipTo,
} from "../../components/UI/Dropdown";
import {
  CartSVG,
  MessageSVG,
  UserSVG,
  CameraSVG,
  StoreSearchSVG,
} from "../../assets/svg/allSvg";
import { getAuth, signOut } from "@firebase/auth";
import { UserAuthContext } from "../../App";
import OrderLogos from "../../assets/homepage/navbar/OrderLogo.png";
import { useNavigate } from "react-router-dom";
import HeroSection from "./HeroSection";
import BestDealsSection from "./BestDealsSection";
// import WebStoreProducts from "./WebStoreProducts";
import CompanyOverview from "./CompanyOverview";
// import OfferSection from "./OfferSection";
import AboutUs from "./AboutUs";
// import WebStoreInquiry from "./WebStoreInquiry";
import ContactSection from "./ContactSection";

const WebStoreNavbar = () => {
  const [underLine, setUnderLine] = useState(false);
  const navigate = useNavigate();

  const [activeSection, setActiveSection] = useState("hero");
  const { userUid, isLoggedIn } = useContext(UserAuthContext);


  const heroRef = useRef(null);
  const bestDealsRef = useRef(null);
  const productsref = useRef(null);
  const webOverviewRef = useRef(null);
  const OfferRef = useRef(null);
  const aboutUsRef = useRef(null);
  const webInquiryRef = useRef(null);
  const contactRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      if (
        heroRef.current &&
        scrollPosition >= heroRef.current.offsetTop - 100
      ) {
        setActiveSection("hero");
      } else if (
        bestDealsRef.current &&
        scrollPosition >= bestDealsRef.current.offsetTop - 100
      ) {
        setActiveSection("bestDeals");
      } else if (
        productsref.current &&
        scrollPosition >= productsref.current.offsetTop - 100
      ) {
        setActiveSection("products");
      } else if (
        webOverviewRef.current &&
        scrollPosition >= webOverviewRef.current.offsetTop - 100
      ) {
        setActiveSection("overview");
      } else if (
        OfferRef.current &&
        scrollPosition >= OfferRef.current.offsetTop - 100
      ) {
        setActiveSection("offer");
      } else if (
        aboutUsRef.current &&
        scrollPosition >= aboutUsRef.current.offsetTop - 100
      ) {
        setActiveSection("aboutUs");
      } else if (
        webInquiryRef.current &&
        scrollPosition >= webInquiryRef.current.offsetTop - 100
      ) {
        setActiveSection("webInquiry");
      } else if (
        contactRef.current &&
        scrollPosition >= contactRef.current.offsetTop - 100
      ) {
        setActiveSection("contact");
      } else {
        setActiveSection("");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleClick = (section) => {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setActiveSection(section);
    }
  };

  return (
    <>
      <div className="w-full h-[83px] bg-white">
        <div className="container max-w-[1240px] mx-auto w-full h-full flex items-center justify-between">
          <div className="flex items-center justify-start gap-x-[33px]">
            <button>
              <img
                src={require("../../assets/WebFront/Naayatrade Final Logo File 1.jpg")}
                alt=""
                className="w-[165px] h-[40px]"
                onClick={() => navigate("/")}
              />
            </button>
            <div className="flex w-[480px] h-[30px] items-center justify-start">
              <div className="flex items-center gap-x-[5px] mr-[8px]">
                <p className="w-[44px] h-[18px] text-[12px] select-none font-regular">
                  Ship to:
                </p>
                {ShipTo}
              </div>
              <hr className="opacity-45 w-[1px] h-[15px] bg-black" />
              <div className="flex items-center mx-[10px] select-none text-[12px] font-regular">
                {Languages}
              </div>
              <hr className="opacity-45 w-[1px] h-[15px] bg-black" />
              <div className="flex items-center mx-[10px] justify-center w-[150px] h-[20px] font-regular text-[12px]">
                <p className="w-[65px] h-[18px] text-[12px] select-none">
                  Currency :
                </p>
                {CurrencyChange}
              </div>
            </div>
          </div>

          <div>
            <div className="flex justify-between">
              <div className="flex gap-x-[10px] w-[330px] justify-end items-center font-regular text-[12px]">
                <button
                  onClick={() => navigate("/orders")}
                  className="flex items-center gap-x-[6px] justify-between w-[70px] h-[24px]"
                >
                  <img
                    src={OrderLogos}
                    alt="OrderLogo"
                    className="w-[18px] h-[19px]"
                  />
                  <p className="w-[47px] h-[18px] text-[12px] select-none">
                    Orders
                  </p>
                </button>
                <hr className="opacity-45 w-[1px] h-[15px] bg-black" />
                <button>
                  <div className="flex gap-x-1 items-center">
                    {CartSVG}
                    <p className="text-[12px]">Cart</p>
                  </div>
                </button>

                <hr className="opacity-45 w-[1px] h-[15px] bg-black" />

                <button>
                  <div className="flex gap-x-1 items-center">
                    {MessageSVG}
                    <p className="text-[12px]">Messages</p>
                  </div>
                </button>
                <hr className="opacity-45 w-[1px] h-[15px] bg-black" />

                {/* <button
                  onClick={() => navigate("/login")}
                  className="flex items-center justify-center"
                >
                  <div className="flex gap-x-1 items-center justify-center">
                    {UserSVG}
                    <p className="text-[12px]">Sign in</p>
                  </div>
                </button> */}


                {!isLoggedIn ? (
                  <button
                    onClick={() => navigate("/login")}
                    className="flex items-center justify-center"
                  >
                    <div className="flex gap-x-1 items-center justify-center">
                      {UserSVG}
                      <button className="text-[12px]">Sign in</button>
                    </div>
                  </button>
                ) : (
                  <p
                    // onClick={() => {
                    //   signOut(userUid);
                    //   deleteCookie("token");
                    // }}
                    className="text-[12px] capitalize cursor-pointer"
                  >
                    {userUid?.currentUser?.displayName}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        <hr className="w-full bg-black h-[2px] opacity-10" />
      </div>

      <div className="w-full h-[76px] bg-white">
        <div className="container max-w-[1240px] mx-auto w-full h-full flex items-center justify-between">
          <div className="flex items-center justify-start">
            <img
              src={require("../../assets/WebFront/image 213.jpg")}
              alt=""
              className="w-[75px] h-[43px]"
            />
            <nav>
              <ul className="font-semibold text-[14px] text-black flex w-[550px] gap-x-[50px] ml-[48px] items-center justify-start mt-[15px]">
                <li className="">
                  <a
                    href="#home"
                    className={`w-[43px] h-[21px] cursor-pointer ${activeSection === "hero" ? "text-orange-500" : ""
                      }`}
                    onClick={() => handleClick("hero")}
                  >
                    Home
                  </a>
                </li>
                <li className="w-[63px] h-[21px] cursor-pointer">
                  <a
                    href="#bestDeals"
                    className={`w-[43px] h-[21px] cursor-pointer ${activeSection === "bestDeals" ? "text-orange-500" : ""
                      }`}
                    onClick={() => handleClick("bestDeals")}
                  >
                    Products
                  </a>
                </li>
                <li className="w-[66px] h-[21px] cursor-pointer">
                  <a
                    href="#overview"
                    className={`w-[43px] h-[21px] cursor-pointer ${activeSection === "overview" ? "text-orange-500" : ""
                      }`}
                    onClick={() => handleClick("overview")}
                  >
                    Overview
                  </a>
                </li>
                <li className="w-[64px] h-[21px] cursor-pointer">
                  <a
                    href="#aboutUs"
                    className={`w-[43px] h-[21px] cursor-pointer ${activeSection === "aboutUs" ? "text-orange-500" : ""
                      }`}
                    onClick={() => handleClick("aboutUs")}
                  >
                    About Us
                  </a>
                </li>
                <li className="w-[90px] h-[21px] cursor-pointer">
                  <a
                    href="#contact"
                    className={`w-[43px] h-[21px] cursor-pointer ${activeSection === "contact" ? "text-orange-500" : ""
                      }`}
                    onClick={() => handleClick("contact")}
                  >
                    Contact Us
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          <div className="flex items-center justify-end">
            <div className="flex justify-between items-center w-[517px] h-[39px] border-2 py-[7px] pr-[11px] rounded-[5px]">
              <div className="flex items-center gap-x-4">
                {UserType()}
                <hr className="opacity-45 w-[1px] h-[20px] bg-black" />
                <input
                  placeholder="What are you looking for ?"
                  className="focus:outline-none placeholder:w-[158px] placeholder:h-[18px] placeholder:text-[12px] placeholder:font-medium"
                />
              </div>
              <div className="flex items-center gap-x-2">
                <button>{CameraSVG}</button>
                <button className="flex items-center text-white gap-x-[5px] bg-[#FF6300] cursor-pointer rounded-[5px] w-[97px] h-[25px] font-medium text-[12px] justify-center">
                  {StoreSearchSVG}
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="w-full bg-black h-[2px] opacity-10" />
      </div>

      {/* <div id="hero" ref={heroRef}>
        {<HeroSection />}
      </div>

      <div id="bestDeals" ref={bestDealsRef}>
        {<BestDealsSection />}
      </div>

      <div id="overview" ref={webOverviewRef}>
        {<CompanyOverview />}
      </div>

      <div id="aboutUs" ref={aboutUsRef}>
        {<AboutUs />}
      </div>

      <div id="contact" ref={contactRef}>
        {<ContactSection />}
      </div> */}
    </>
  );
};

export default WebStoreNavbar;
